// خلاصه‌ی کارهایی که سامانه در هر بخش انجام می‌دهد؛ با زدن آیکن «راهنما» در هر صفحه و در «راهنمای سامانه» نمایش داده می‌شود
export interface PageInfo {
  title: string;
  icon: string;
  group: string;
  points: string[];
  // فهرست شماره‌دار (مراحل)
  ordered?: boolean;
  // متن پایانی پس از فهرست
  footer?: string;
}

export const PAGE_INFO: Record<string, PageInfo> = {
  '': {
    title: 'داشبورد',
    icon: 'pi pi-home',
    group: 'داشبورد',
    points: [
      'آمار رزروها، درآمد قطعی و میزان اشغال اتاق‌ها در بازه‌ی انتخابی (امروز، هفته، ماه یا بازه‌ی دلخواه) نمایش داده می‌شود.',
      'تعداد رزروها به تفکیک وضعیت (در انتظار پرداخت، پرداخت‌شده، تأییدشده و لغوشده) قابل مشاهده است.',
      'نمودار ساعات پرتردد و عملکرد هر اتاق، تصویر روشنی از وضعیت کسب‌وکار ارائه می‌دهد.',
      'فهرست رزروهای پیش‌رو برای پیگیری سریع در دسترس است.',
      'رزروهای پیش‌رو به‌صورت «نام | کد | ساعت شروع» نمایش داده می‌شوند؛ با زدن روی هر رزرو، اطلاعات کامل رزرو و مشتری باز می‌شود و با دکمه‌ی «ثبت ورود»، ورود مشتری ثبت می‌شود.',
    ],
  },
  'reservations/new': {
    title: 'ثبت رزرو جدید',
    icon: 'pi pi-calendar-plus',
    group: 'رزرو و مشتریان',
    points: [
      'پس از انتخاب تاریخ، می‌توانید ساعات خالی را بر اساس بازه‌ی زمانی (از ساعت تا ساعت) و اتاق فیلتر کنید؛ با انتخاب هر فیلتر، گزینه‌های فیلترهای دیگر نیز به‌روز می‌شوند.',
      'در صورتی که اتاقی انتخاب نشود، ساعات خالی همه‌ی اتاق‌ها نمایش داده می‌شود.',
      'با وارد کردن شماره موبایل، اطلاعات مشتریِ ثبت‌شده به‌طور خودکار درج می‌شود. ویرایش این اطلاعات به دسترسی مربوط نیاز دارد و هر تغییر در سوابق مشتری ثبت می‌شود.',
      'تعداد نفرات می‌تواند بیشتر از ظرفیت اتاق باشد؛ در این حالت عبارت «بیش از ظرفیت» نمایش داده می‌شود.',
      'با زدن دکمه‌ی «پرداخت و ثبت رزرو»، روش پرداخت انتخاب می‌شود: کارتخوان، کارتخوان متصل، ارسال لینک پرداخت، نقدی، کارت به کارت یا اعتباری.',
      'رزرو تا زمان پرداخت در وضعیت «در انتظار پرداخت» می‌ماند و اگر در مهلت تعیین‌شده پرداخت نشود، به‌طور خودکار لغو و موضوع از طریق پیامک به مشتری اطلاع داده می‌شود.',
    ],
  },
  'room-availability': {
    title: 'وضعیت اتاق‌ها',
    icon: 'pi pi-calendar',
    group: 'رزرو و مشتریان',
    points: [
      'تقویم ماهانه‌ی هر اتاق، روزهای خالی، نیمه‌پر و پر را مشخص می‌کند.',
      'وضعیت بازه‌های هر روز (خالی، رزروشده، غیرفعال یا در حال تکمیل توسط مشتری) قابل مشاهده است و از همین‌جا می‌توان رزرو سریع ثبت کرد.',
      'روزهای گذشته با خط روی تاریخ و روزهای غیرقابل رزرو آینده با نماد قفل مشخص شده‌اند.',
      'تقویم هر بار یک ماه را نشان می‌دهد و با دکمه‌های ماه قبل و بعد جابه‌جا می‌شود.',
    ],
  },
  reservations: {
    title: 'لیست رزروها',
    icon: 'pi pi-list',
    group: 'رزرو و مشتریان',
    points: [
      'همه‌ی رزروها را می‌توانید بر اساس وضعیت، اتاق، مشتری و تاریخ جست‌وجو و فیلتر کنید.',
      'وضعیت‌ها با رنگ مشخص شده‌اند: در انتظار پرداخت (زرد)، پرداخت‌شده (سبز)، تأییدشده (آبی) و لغوشده (قرمز).',
      'با تغییر وضعیت رزرو به «تأیید» یا «لغو»، مشتری از طریق پیامک مطلع می‌شود.',
      'دریافت وجه با روش‌های فعال، ارسال لینک پرداخت و بازگرداندن مبلغ به کیف پول مشتری از همین صفحه انجام می‌شود.',
      'جدیدترین رزروها در ابتدای فهرست نمایش داده می‌شوند.',
    ],
  },
  customers: {
    title: 'مشتریان و کیف پول',
    icon: 'pi pi-id-card',
    group: 'رزرو و مشتریان',
    points: [
      'فهرست مشتریان همراه با تعداد رزرو، مجموع پرداخت‌ها و تاریخ آخرین رزرو نمایش داده می‌شود.',
      'اطلاعات مشتری با داشتن دسترسی قابل ویرایش است و سوابق همه‌ی تغییرات قابل مشاهده است.',
      'موجودی کیف پول مشتری قابل افزایش یا کاهش است و گردش آن ثبت می‌شود.',
      'برای هر مشتری می‌توان سقف اعتبار تعیین کرد، بدهی اعتباری او را مشاهده و تسویه کرد.',
      'با زدن روی ردیف هر مشتری، پروفایل او همراه با رزروها و امکان ویرایش باز می‌شود.',
    ],
  },
  'payment-links': {
    title: 'لینک‌های پرداخت',
    icon: 'pi pi-link',
    group: 'رزرو و مشتریان',
    points: [
      'برای یک رزرو یا فاکتور دلخواه، لینک پرداخت ساخته و از طریق پیامک برای مشتری ارسال می‌شود.',
      'وضعیت لینک‌ها (فعال، پرداخت‌شده یا باطل‌شده) قابل پیگیری است و می‌توان لینک را دوباره ارسال کرد.',
      'در این فهرست فقط لینک‌هایی نمایش داده می‌شوند که در همین بخش ساخته شده‌اند؛ لینک‌های پرداخت رزروها در «لیست رزروها» قابل مشاهده‌اند.',
    ],
  },
  rooms: {
    title: 'مدیریت اتاق‌ها',
    icon: 'pi pi-home',
    group: 'خلوت‌نشین',
    points: [
      'اتاق‌ها همراه با ظرفیت، توضیحات، امکانات و تصاویر یا ویدیو تعریف می‌شوند.',
      'هر اتاق قابل فعال یا غیرفعال شدن است و بازه‌های زمانی قابل رزرو آن تعیین می‌شود.',
    ],
  },
  amenities: {
    title: 'مدیریت امکانات',
    icon: 'pi pi-list',
    group: 'خلوت‌نشین',
    points: ['امکانات اتاق‌ها (مانند ویدئو پروژکتور یا سیستم صوتی) تعریف می‌شوند تا در معرفی اتاق به مشتری نمایش داده شوند.'],
  },
  'time-slots': {
    title: 'بازه‌های زمانی',
    icon: 'pi pi-clock',
    group: 'خلوت‌نشین',
    points: [
      'گروه‌های بازه‌ی زمانی (مثلاً بازه‌های دوساعته از ۱۰ صبح تا ۲ بامداد) ساخته و به اتاق‌ها اختصاص داده می‌شوند.',
      'هر بازه جزو تاریخی است که در آن شروع می‌شود؛ مثلاً بازه‌ی ۲ تا ۴ بامداد ۲۵ مهر جزو ۲۵ مهر است و پیش از بازه‌های ظهر همان روز نمایش داده می‌شود.',
    ],
  },
  pricing: {
    title: 'قیمت‌گذاری',
    icon: 'pi pi-tags',
    group: 'خلوت‌نشین',
    points: [
      'قیمت هر بازه بر اساس اتاق، روزهای هفته، تاریخ یا مناسبت تعیین می‌شود.',
      'قیمت‌ها از طریق فایل اکسل یا CSV قابل ورود و خروج هستند.',
    ],
  },
  'booking-blocks': {
    title: 'غیرفعال‌سازی رزرو',
    icon: 'pi pi-ban',
    group: 'خلوت‌نشین',
    points: [
      'امکان رزرو برای یک اتاق، روز یا بازه‌ی مشخص (مثلاً به دلیل تعمیرات یا تعطیلی) بسته می‌شود.',
      'اگر در این بازه رزرو پرداخت‌شده یا تأییدشده‌ای وجود داشته باشد، به مدیریت هشدار داده می‌شود.',
      '«غیرفعال کردن آنلاین» (زرد) فقط رزرو آنلاین مشتریان را می‌بندد و پرسنل همچنان از پنل رزرو ثبت می‌کنند؛ «غیرفعال کردن کلی» (قرمز) رزرو را برای همه می‌بندد.',
    ],
  },
  users: {
    title: 'کاربران و دسترسی‌ها',
    icon: 'pi pi-users',
    group: 'مدیریت سامانه',
    points: [
      'مدیران و پرسنل در این بخش تعریف می‌شوند؛ نام کاربری هر کاربر همان شماره موبایل اوست.',
      'ورود به پنل با شماره موبایل و رمز عبور یا با کد یکبار مصرف پیامکی انجام می‌شود.',
      'دسترسی‌های پرسنل به تفکیک زیردسته‌ها (رزرو، مشتریان، پرداخت، اتاق‌ها، پیامک و تنظیمات) انتخاب می‌شود.',
      'حساب کاربری هر کاربر قابل غیرفعال شدن است.',
      'برای هر کاربر عنوان دسترسی (مثلاً «مدیر» یا «پذیرش») تعیین می‌شود که کنار نام او در نوار بالا نمایش داده می‌شود.',
      'دسترسی تنظیمات و گزارش‌ها از هم جدا است؛ مثلاً «تنظیمات پیامک» جدا از «مشاهده‌ی پیامک‌های ارسالی» و «مشاهده‌ی کدهای ارسالی».',
    ],
  },
  sms: {
    title: 'مدیریت پیامک',
    icon: 'pi pi-envelope',
    group: 'مدیریت سامانه',
    points: [
      'سامانه به سرویس‌های پیامکی کاوه‌نگار، SMS.ir، ملی‌پیامک، IPPanel (فراز اس‌ام‌اس)، قاصدک و هر وب‌سرویس دیگری قابل اتصال است.',
      'پیامک‌های اطلاع‌رسانی وضعیت رزرو به مشتری (پرداخت، تأیید، لغو و لغو خودکار) قابل فعال یا غیرفعال شدن هستند.',
      'همه‌ی پیامک‌های ارسالی همراه با وضعیت ارسال و علت خطا قابل مشاهده‌اند.',
      'برای اطمینان از درستی تنظیمات، می‌توان پیامک آزمایشی ارسال کرد.',
      'اتصال به ناواتل نیز فراهم است.',
      'متن هر پیامک (کد ورود، ثبت، پرداخت، تأیید، لغو، لینک پرداخت، بازگشت وجه و شارژ کیف پول) قابل ویرایش است و در سرویس‌های دارای «ارسال با الگو»، کد الگو تعیین می‌شود.',
      'کدهای یکبار مصرف ارسال‌شده فقط برای کاربران دارای دسترسی «مشاهده‌ی کدها» نمایش داده می‌شوند.',
    ],
  },
  'payments-management': {
    title: 'مدیریت پرداخت',
    icon: 'pi pi-credit-card',
    group: 'مدیریت سامانه',
    points: [
      'روش‌های پرداخت (نقدی، کارتخوان، کارت به کارت، اعتباری، لینک پرداخت و کیف پول) قابل فعال یا غیرفعال شدن هستند.',
      'اتصال به درگاه‌های پرداخت آنلاین (زرین‌پال و زیبال) در این بخش تنظیم می‌شود.',
      'کارتخوان‌های متصل به سیستم (PC-POS) تعریف می‌شوند و اتصال آن‌ها قابل بررسی است.',
      'گزارش همه‌ی تراکنش‌ها به تفکیک روش پرداخت در دسترس است.',
      'برای کارت به کارت چند حساب بانکی با نام تعریف می‌شود و اجباری بودن شماره پیگیری کارتخوان غیرمتصل قابل تنظیم است.',
      'درگاه‌های پرداخت اعتباری تارا و اسنپ‌پی قابل اتصال هستند.',
      'کارتخوان‌های سامان (SEP) از طریق نرم‌افزار واسط PC-POS متصل می‌شوند.',
      'بسته‌های شارژ کیف پول با مبلغ، ضریب شارژ و تاریخ پایان تعریف می‌شوند.',
    ],
  },
  appearance: {
    title: 'ظاهر و رنگ‌بندی',
    icon: 'pi pi-palette',
    group: 'مدیریت سامانه',
    points: [
      'لوگو و نام سامانه تعیین می‌شود و تغییر آن در همه‌ی بخش‌ها (پنل، صفحه‌ی ورود، صفحه‌ی مشتری و عنوان و آیکن مرورگر) اعمال می‌شود.',
      'رنگ‌های سازمانی شامل دو رنگ اجباری و دو رنگ اختیاری (علاوه بر مشکی و سفید) است و می‌توان رنگ‌ها را ملایم و متعادل کرد.',
      'اندازه‌ی قلم، طرح، ساختار منو و حالت تیره‌ی پیش‌فرض برای پنل مدیریت و پنل پرسنل به‌صورت یکسان تعیین می‌شود.',
      'رنگ‌های صفحه‌ی مشتری از بین رنگ‌های سازمانی انتخاب می‌شوند و درج عنوان و زیرعنوان در این صفحه اختیاری است.',
      'اندازه‌ی لوگو و عنوان صفحه‌ی ورود و اندازه‌ی لوگو، عنوان و زیرعنوان صفحه‌ی مشتری قابل تنظیم است.',
      'حالت نمایش در سه حالت روشن، تیره و «مطابق دستگاه» انتخاب می‌شود.',
    ],
  },
  settings: {
    title: 'تنظیمات رزرو',
    icon: 'pi pi-sliders-h',
    group: 'مدیریت سامانه',
    points: [
      'تعداد روزهایی که مشتریان می‌توانند از پیش رزرو کنند، محدود می‌شود.',
      'مدت نگه‌داشتن بازه در زمان تکمیل رزرو و مهلت پرداخت تعیین می‌شود؛ پس از پایان مهلت، رزرو پرداخت‌نشده لغو خواهد شد.',
      'قوانین رزرو که مشتری پیش از پرداخت باید آن‌ها را بپذیرد، در این بخش ویرایش می‌شود.',
    ],
  },
  alerts: {
    title: 'هشدارها',
    icon: 'pi pi-bell',
    group: 'مدیریت سامانه',
    points: [
      'برای رویدادهایی مانند رزرو جدید، پرداخت و نزدیک شدن به زمان شروع یا پایان رزرو، هشدار صوتی و نمایشی پخش می‌شود.',
      'زمان ارسال هشدار پیش از شروع یا پایان رزرو قابل تنظیم است.',
      'تنظیمات صدا و اعلان برای هر دستگاه به‌صورت جداگانه ذخیره می‌شود.',
    ],
  },
  logs: {
    title: 'لاگ سامانه',
    icon: 'pi pi-history',
    group: 'مدیریت سامانه',
    points: [
      'همه‌ی عملیات کاربران پنل (ثبت، ویرایش و حذف در هر بخش) همراه با کاربر، تاریخ، ساعت، نتیجه و نشانی IP ثبت می‌شود.',
      'ورود، خروج و تلاش‌های ناموفق ورود نیز در همین لاگ ثبت می‌شود.',
      'لاگ بر اساس کاربر، بخش سامانه، نوع رویداد و بازه‌ی تاریخ قابل فیلتر و جست‌وجو است.',
    ],
  },
  profile: {
    title: 'پروفایل',
    icon: 'pi pi-user',
    group: 'مدیریت سامانه',
    points: ['اطلاعات حساب کاربری نمایش داده می‌شود و نام و رمز عبور قابل تغییر است.'],
  },
  userLog: {
    title: 'گزارش ورود کاربران',
    icon: 'pi pi-history',
    group: 'مدیریت سامانه',
    points: [
      'ورود، خروج و تلاش‌های ناموفق ورود هر کاربر همراه با روش ورود، تاریخ، ساعت و نشانی IP ثبت می‌شود.',
      'گزارش بر اساس نام یا شماره موبایل قابل جست‌وجو و بر اساس نوع رویداد قابل فیلتر است.',
    ],
  },
  help: {
    title: 'راهنمای سامانه',
    icon: 'pi pi-question-circle',
    group: 'راهنما',
    points: ['خلاصه‌ای از کارهایی که سامانه در هر بخش انجام می‌دهد، در این صفحه گردآوری شده است.'],
  },
};

// صفحه‌ی رزرو آنلاین مشتری
export const CUSTOMER_INFO: PageInfo = {
  title: 'راهنمای رزرو آنلاین',
  icon: 'pi pi-info-circle',
  group: 'صفحه‌ی مشتری',
  ordered: true,
  points: [
    'شماره موبایل خود را وارد کنید و کد تأییدی را که از طریق پیامک برایتان ارسال می‌شود، وارد نمایید.',
    'در اولین ورود، اطلاعات خود شامل نام و نام خانوادگی را ثبت کنید.',
    'تاریخ و ساعت موردنظر خود را انتخاب کنید، سپس اتاق‌های خالی را مشاهده کرده و اتاق دلخواهتان را انتخاب کنید.',
    'پس از ثبت رزرو، فاکتور را مشاهده کرده و مبلغ آن را از طریق درگاه پرداخت، کیف پول یا اعتبار خود پرداخت کنید.',
    'پس از پرداخت موفق، رزرو شما تأیید می‌شود.',
    'شارژ کیف پول: امکان شارژ کیف پول نیز از طریق همین صفحه فراهم است.',
  ],
  footer: 'اطلاع‌رسانی پیامکی: وضعیت پرداخت و همچنین تأیید یا لغو رزرو، از طریق پیامک به شما اطلاع داده خواهد شد.',
};
